import React, { useEffect, useState } from 'react';
import { Row, Col, message, Spin, Space, Button, Typography, Form } from 'antd';
import ListCard from 'Molecules/ListCard';
import HeadingChip from 'Molecules/HeadingChip';
import { useDispatch, useSelector } from 'react-redux';
import { getSubCategories } from '../../../../../ducks/actions'
import { addSubCategory, editSubCategory, removeSubCategory, bulkRemoveSubCategories } from '../../../../../ducks/services'
import ActionButton from 'Molecules/ActionButton';
import { Popup } from 'Atoms/Popup';
import { LoadingOutlined } from '@ant-design/icons';
import { SelectField, InputField } from 'Atoms/FormElement';
import { useForm } from 'react-hook-form';
import { useTranslate } from 'Translate';

const antIcon = <LoadingOutlined spin />;
const { Title } = Typography;

export default (props) => {
  const dispatch = useDispatch();
  const { id, meta, activeTab, allowedEdit, allowedDelete } = props;
  const { control, formState: { errors }, handleSubmit, setValue, getValues } = useForm();
  const subCategory = useSelector((state) => state.product.subCategory);
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(25);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [visible, setVisible] = useState(false);
  const i18n = useTranslate();
  const { t } = i18n;

  const colName = [
    {
      title: t("General.code"),
      dataIndex: 'code',
      className: 'enable-click',
      key: 'code',
      sorter: true
    },
    {
      title: t("General.desc"),
      dataIndex: 'name',
      className: 'enable-click',
      key: 'name',
      sorter: true
    },
    {
      title: "",
      dataIndex: "action",
      key: "action",
      width: 200,
      render: (text, record) =>
        <ActionButton
          title="family_group"
          btnAction1={() => {
            setValue('id', record?.id);
            setValue('code', record?.code);
            setValue('name', record?.name);
            setVisible(true);
          }}
          recordId={record.id}
          onRemove={allowedDelete && onRemove}
          setLoading={props.setLoading}
          loading={props.loading}
        />
    }
  ];

  const addNew = () => { 
    setVisible(true);
    setValue('id', null);
    setValue('code', '');
    setValue('name', '');
  }

  const btnList = [
    {
      title: t("Product.confirm_remove_select_fam_grp"),
      text: t("General.bulk_remove"),
      classes: 'red-btn text-white attendance-success',
      permit: true,
      action: () => onBulkRemove(),
    },
    {
      text: `+ ${t("Product.new_fam_grp")}`,
      classes: 'attendance-success',
      action: () => addNew(),
    },
  ];

  useEffect(() => {
    if (activeTab === "2")
    dispatch(getSubCategories(1, limit, '', '', props.setLoading, id));
  }, [activeTab]);

  const onTableChange = (pagination, filters, sorter) => {
    setPage(pagination.current);
    setLimit(pagination.pageSize);
    if (sorter.order) {
      dispatch(getSubCategories(pagination.current, pagination.pageSize, sorter.order, sorter.columnKey, props.setLoading, id));
    } else {
      dispatch(getSubCategories(pagination.current, pagination.pageSize, '', '', props.setLoading, id));
    }
  }

  const onSelectChange = (newSelectedRowKeys) => {
    setSelectedRowKeys(newSelectedRowKeys);
  };

  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
  };

  const onRemove = async (subCatId) => {
    props.setLoading(true);

    const payload = {
      category_id: id,
      sub_category_id: subCatId,
      status_event: 'remove'
    }

    await removeSubCategory(payload).then(res => {
      props.setLoading(false);
      if (res.data.code === 200) {
        message.success(t("Product.fam_grp_remove_success"));
        setTimeout(() => dispatch(getSubCategories(1, limit, '', '', props.setLoading, id)), 500);
      }
    }).catch(e => {
      props.setLoading(false);
      message.error(e.message ?? t("General.something_went_wrong"));
    })
  }

  const onBulkRemove = async () => {
    props.setLoading(true);

    const payload = {
      category_id: id,
      sub_categories: JSON.stringify(selectedRowKeys)
    }

    await bulkRemoveSubCategories(payload).then(res => {
      props.setLoading(false);
      if (res.data.code === 200) {
        rowSelection.onChange([]);
        message.success(t("Product.fam_grps_remove_success"));
        setTimeout(() => dispatch(getSubCategories(1, limit, '', '', props.setLoading, id)), 500);
      }
    }).catch(e => {
      props.setLoading(false);
      message.error(e.message ?? t("General.something_went_wrong"));
    })
  }

  const onFinish = async (val) => {
    props.setLoading(true);
    const payload = {
      code: val?.code,
      name: val?.name,
      sub_category_id: val?.id,
      category_id: id,
    }

    await (val?.id ? editSubCategory : addSubCategory)(payload).then(res => {
      props.setLoading(false);
      if (res.data.code === 200) {
        message.success(`${val?.id ? t("Product.update_fam_grp_success") : t("Product.add_fam_grp_success")}`);
        setVisible(false);
        setValue('id', null);
        setValue('code', '');
        setValue('name', '');
        setTimeout(() => dispatch(getSubCategories(1, limit, '', '', props.setLoading, id)), 500);
      } else {
        message.error(res.data.message);
      }
    }).catch(e => {
      props.setLoading(false);
      message.error(e.message ?? t("General.something_went_wrong"));
    })
  };

  const popup = {
    closable: false,
    visibility: visible,
    content: <Spin indicator={antIcon} size="large" spinning={props.loading}>
      <Form layout="vertical" onFinish={handleSubmit(onFinish)}>
        <Space direction='vertical' size={15} className='w-100'>
          <Row gutter={[10, 15]}>
            <Col span={24}>
              <Title level={4} className='m-0'>
                {getValues('id') ? t("General.edit") : t("General.add")} {t("Product.family_group")}
              </Title>
            </Col>
            <Col span={12}>
              <InputField
                fieldname='id'
                label=''
                class='d-none'
                initValue={''}
                control={control}
              />
              <InputField
                isRequired={visible}
                fieldname='code'
                label={t("General.code")}
                class='mb-0 w-100'
                initValue={''}
                control={control}
                iProps={{ placeholder: t("General.pls_enter"), disabled: !allowedEdit }}
                rules={{
                  required: t("General.code_req"),
                }}
                validate={errors.code && 'error'}
                validMessage={errors.code && errors.code.message}
              />
            </Col>
            <Col span={12}>
              <InputField
                isRequired={visible}
                fieldname='name'
                label={t("General.desc")}
                class='mb-0 w-100'
                initValue={''}
                control={control}
                iProps={{ placeholder: t("General.pls_enter"), disabled: !allowedEdit }}
                rules={{
                  required: t("General.desc_req"),
                }}
                validate={errors.name && 'error'}
                validMessage={errors.name && errors.name.message}
              />
            </Col>
          </Row>
          <Row gutter={10}>
            <Col span={12}><Button size='large' danger type="primary" className='w-100' onClick={() => {
              setVisible(false);
              setValue('id', null);
              setValue('code', '');
              setValue('name', '');
            }}>{t("General.cancel")}</Button></Col>
            {
              allowedEdit &&
              <Col span={12}><Button size='large' type="primary" className='green-btn w-100' htmlType='submit'>{t("General.confirm")}</Button></Col>
            }
          </Row>
        </Space>
      </Form>
    </Spin>,
    width: 536,
    onCancel: () => {
      setVisible(false);
      setValue('id', null);
      setValue('code', '');
      setValue('name', '');
    },
  };

  const onClickRow = (record) => {
    return {
      onClick: (e) => {
        if (e.target.closest(".enable-click")){
          setValue('id', record?.id);
          setValue('code', record?.code);
          setValue('name', record?.name);
          setVisible(true);
        }
      },
    };
  };

  return (
    <>
      <Row gutter={[10, 10]}>
        <Col span={24}>
          <HeadingChip title={t("Product.family_group")} btnList={allowedEdit ? btnList : null} btnHidden={selectedRowKeys.length <= 0} />
        </Col>
        <Col span={24} className="clickRow">
          <ListCard
            onRow={onClickRow}
            listClass="nopad"
            ListData={subCategory?.list?.map(x => ({ ...x, key: x.id }))}
            onChange={onTableChange}
            ListCol={colName}
            rowSelection={allowedEdit && rowSelection}
            pagination={{
              total: subCategory?.total_count,
              current: page,
              pageSize: limit
            }}
          />
        </Col>
      </Row>
      <Popup {...popup} />
    </>
  )
}